export enum Role {
  MANAGER = 'manager',
  AGENT = 'agent',
}
